import { create } from 'zustand';

import { features } from './features/features';

type ToolboxState = {
  isOpen: boolean;
  toggle: () => void;
  getIsAnyToolActive: () => boolean;
};

export const useToolboxState = create<ToolboxState>((set) => ({
  isOpen: false,
  toggle: () => set((state) => ({ isOpen: !state.isOpen })),
  getIsAnyToolActive: () =>
    features.some((feature) => feature.useState.getState().getIsActive()),
}));
